import React, { useEffect, useState, useRef } from "react";
import "./SnakeAndLadder.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import { userGameRewards } from "../../../apis/user";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../../Task/Task";
import { io } from "socket.io-client";
import { v4 as uuidv4 } from "uuid";
import { Base_Url } from "../../../apis/baseurl";
import Swal from "sweetalert2";

const SnakeAndLadder = () => {
  const { userDetails, updateUserInfo, watchScreen, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [socket, setSocket] = useState(null);
  const [board, setBoard] = useState([]);
  const [diceValue, setDiceValue] = useState(1);
  const [myPosition, setMyPosition] = useState(1);
  const [opponentPosition, setOpponentPosition] = useState(1);
  const [rolling, setRolling] = useState(false);
  const [diceRolling, setDiceRolling] = useState(false);
  const [opponentDiceValue, setOpponentDiceValue] = useState(1);
  const [opponentDiceRolling, setOpponentDiceRolling] = useState(false);
  const [gameStatus, setGameStatus] = useState("initial"); // 'initial', 'waiting', 'playing', 'finished'
  const [winner, setWinner] = useState(null);
  const [gameFinished, setGameFinished] = useState(false);
  const [score, setScore] = useState(0);
  const [roomId, setRoomId] = useState(null);
  const [isMyTurn, setIsMyTurn] = useState(false);
  const [playerSymbol, setPlayerSymbol] = useState(null);
  const [players, setPlayers] = useState([]);
  const [currentPlayer, setCurrentPlayer] = useState(null);
  const [playAgainRequested, setPlayAgainRequested] = useState(false);
  const [iRequestedPlayAgain, setIRequestedPlayAgain] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showGameModeSelection, setShowGameModeSelection] = useState(true);
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const [inputRoomId, setInputRoomId] = useState("");
  const [copySuccess, setCopySuccess] = useState("");
  const [gameMode, setGameMode] = useState(null); // 'single', 'multiplayer'
  const [computerThinking, setComputerThinking] = useState(false);
  const waitingTimerRef = useRef(null);
  const counterRef = useRef(null);
  const playClick = useAudio();
  const [showBettingUI, setShowBettingUI] = useState(false);
const [betAmount, setBetAmount] = useState(1000);
const apiCallMadeRef = useRef(false);
  const [lastWinnerSocketId, setLastWinnerSocketId] = useState(null);
  const diceFaces = ["", "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice1.png", 
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice2.png",
     "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice3.png", 
     "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice4.png",
      "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice5.png",
       "https://d1ccopf5cw1hft.cloudfront.net/s3data/dice6.png"];

  // Snakes and Ladders mapping
  const jumps = {
    5: 25,
    10: 29,
    22: 41,
    28: 55,
    44: 95,
    70: 89,
    79: 81,
    99: 7,
    92: 35,
    73: 53,
    78: 39,
    37: 17,
    31: 14,
  };

  // Initialize socket connection
  useEffect(() => {
    const newSocket = io(Base_Url.base_url, {
      auth: {
        token: localStorage.getItem("token"),
      },
    });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Connected to server");
    });

    newSocket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    return () => newSocket.disconnect();
  }, []);

  // Socket event listeners
  useEffect(() => {
    if (!socket) return;

    socket.on("gameState", (gameState) => {
      console.log("Received game state:", gameState);

      if (gameState.board) setBoard(gameState.board);
      if (gameState.players) {
        setPlayers(gameState.players);
        const playerIndex = gameState.players.indexOf(socket.id);
        setPlayerSymbol(playerIndex === 0 ? "Player 1" : "Player 2");
      }
      if (gameState.currentPlayer) {
        setCurrentPlayer(gameState.currentPlayer);
        setIsMyTurn(gameState.currentPlayer === socket.id);
      }
      if (gameState.gameStatus) setGameStatus(gameState.gameStatus);
      if (gameState.roomId) setRoomId(gameState.roomId);
      // Handle position updates based on which player we are
      if (gameState.players && gameState.position && gameState.opponentPosition) {
        const playerIndex = gameState.players.indexOf(socket.id);
        if (playerIndex === 0) {
          // Player 1: position is myPosition, opponentPosition is opponent's
          setMyPosition(gameState.position);
          setOpponentPosition(gameState.opponentPosition);
        } else {
          // Player 2: position is opponent's, opponentPosition is myPosition
          setMyPosition(gameState.opponentPosition);
          setOpponentPosition(gameState.position);
        }
      }

      if (gameState.gameStatus === "playing" && players.length === 2) {
        setIsMyTurn(gameState.currentPlayer === socket.id);
      }
      
      // Handle opponent dice roll animation and messages
      if (gameState.currentPlayer !== socket.id) {
        // Handle roll message
        if (gameState.rollMessage) {
          setSuccessMessage(gameState.rollMessage);
          setTimeout(() => setSuccessMessage(""), 3000);
        }
        
      // Handle opponent's dice value and movement
      if (gameState.opponentDiceValue !== undefined) {
        setOpponentDiceValue(gameState.opponentDiceValue);
        
        // If we have a movement update (position change), animate it step by step
        if (gameState.opponentMoving && gameState.opponentTargetPosition !== undefined) {
          // Get the current position and target position
          const currentPos = opponentPosition;
          const targetPos = gameState.opponentTargetPosition;
          
          // Only animate if we're not already at the target
          if (currentPos !== targetPos) {
            // Calculate the number of steps to move
            const steps = targetPos - currentPos;
            
            // Animate the movement step by step
            let step = 0;
            let current = currentPos;
            
            const moveInterval = setInterval(() => {
              if (step < steps) {
                current++;
                setOpponentPosition(current);
                step++;
              } else {
                clearInterval(moveInterval);
                
                // Check if there's a snake or ladder at the final position
                if (jumps[current]) {
                  // Show a small delay before jumping
                  setTimeout(() => {
                    setOpponentPosition(jumps[current]);
                  }, 300);
                }
              }
            }, 300);
          }
        }
      }
      }

      if (gameState.gameStatus === "finished") {
        setGameFinished(true);
        if (gameState.winner) {
          // Store the winner's socket ID for play again functionality
          setLastWinnerSocketId(gameState.winner);
          
          // Convert socket ID to readable player name for display
          let winnerDisplay = gameState.winner;
          if (gameState.players && gameState.players.includes(gameState.winner)) {
            const winnerIndex = gameState.players.indexOf(gameState.winner);
            winnerDisplay = winnerIndex === 0 ? "Player 1" : "Player 2";
          }
          setWinner(winnerDisplay);
          
          // Determine if current player won based on socket ID comparison
          const isCurrentPlayerWinner = gameState.winner === socket.id;
          if (isCurrentPlayerWinner) {
            const points = userDetails?.earlyUsersLimitReached ? 1000 : 2000;
            setScore(points);
            if (!apiCallMadeRef.current){
            handleApiResponse(points.toString());
            }
          } else {
            const points = 0;
            setScore(points);
            handleApiResponse(points.toString());
          }
        } else {
          // Set points to 0 for draws or other game endings
          const points = 0;
          setScore(points);
          handleApiResponse(points.toString());
        }
      }
    });

    socket.on("playerJoined", ({ players, roomId }) => {
      setPlayers(players);
      setRoomId(roomId);

      if (players.length === 2) {
        // Set initial positions based on which player we are
        const playerIndex = players.indexOf(socket.id);
        if (playerIndex === 0) {
          // Player 1: position is myPosition, opponentPosition is opponent's
          setMyPosition(1);
          setOpponentPosition(1);
        } else {
          // Player 2: position is opponent's, opponentPosition is myPosition
          setMyPosition(1);
          setOpponentPosition(1);
        }
        
        const initialGameState = {
          board: board,
          players: players,
          currentPlayer: players[0],
          gameStatus: "playing",
          roomId: roomId,
          position: 1,
          opponentPosition: 1,
          points: {
            winner: 0,
            loser: 0,
            winnerSocketId: null,
            loserSocketId: null
          }
        };

        socket.emit("updateGameState", initialGameState);
      }
    });

    socket.on("playerLeft", () => {
      console.log("Other player disconnected");
      setWinner("Disconnected");
      setGameStatus("finished");
      setGameFinished(true);
      // Set points to 0 when opponent disconnects
      setScore(0);
      handleApiResponse("0");
      alert("Other player disconnected");
    });

    socket.on("roomFull", () => {
      console.log("Room is full");
      setErrorMessage("Room is full. Please try another room.");
      setGameStatus("initial");
    });

    socket.on("playAgainRequest", (data) => {
      console.log("Other player wants to play again");
      setPlayAgainRequested(true);
      setIRequestedPlayAgain(false);
    });

    socket.on("playAgainConfirmed", (gameState) => {
      console.log("Other player confirmed play again");
      if (gameState.board) setBoard(gameState.board);
      if (gameState.players) {
        setPlayers(gameState.players);
        const playerIndex = gameState.players.indexOf(socket.id);
        setPlayerSymbol(playerIndex === 0 ? "Player 1" : "Player 2");
      }
      if (gameState.currentPlayer) {
        setCurrentPlayer(gameState.currentPlayer);
        setIsMyTurn(gameState.currentPlayer === socket.id);
      }
      if (gameState.gameStatus) setGameStatus(gameState.gameStatus);
      // Handle position updates based on which player we are
      if (gameState.players && gameState.position && gameState.opponentPosition) {
        const playerIndex = gameState.players.indexOf(socket.id);
        if (playerIndex === 0) {
          // Player 1: position is myPosition, opponentPosition is opponent's
          setMyPosition(gameState.position);
          setOpponentPosition(gameState.opponentPosition);
        } else {
          // Player 2: position is opponent's, opponentPosition is myPosition
          setMyPosition(gameState.opponentPosition);
          setOpponentPosition(gameState.position);
        }
      }

      setWinner(null);
      setGameFinished(false);
      setShowTimeoutPopup(false);
      setPlayAgainRequested(false);
      setIRequestedPlayAgain(false);
      apiCallMadeRef.current = false; // Reset API call flag for new game
      });

    socket.on("roomExpired", (data) => {
      if (roomId === data.roomId) {
        // Don't reset game state if opponent already disconnected
        // This prevents redirecting the remaining player when opponent leaves
        if (winner !== "Disconnected") {
          setRoomId(null);
          setGameStatus("initial");
          setWinner(null);
          setGameFinished(false);
          setMyPosition(1);
          setOpponentPosition(1);
          setPlayers([]);
          setCurrentPlayer(null);
          setPlayAgainRequested(false);
          setIRequestedPlayAgain(false);
        }
      } else {
        setErrorMessage(
          data.message || "This room has expired and cannot be joined."
        );
        setGameStatus("initial");
        setTimeout(() => setErrorMessage(""), 5000);
      }
    });

    socket.on("roomDeleted", (data) => {
      // Room has been successfully deleted
    });

    socket.on("roomNotFound", (data) => {
      console.log("Room not found:", data);
      setErrorMessage("Room not found. Please check the Room ID and try again.");
      setGameStatus("initial");
      setTimeout(() => setErrorMessage(""), 5000);
    });

    socket.on("error", (error) => {
      console.log("Socket error:", error);
      setErrorMessage(error || "An error occurred. Please try again.");
      setGameStatus("initial");
      setTimeout(() => setErrorMessage(""), 5000);
    });

    return () => {
      socket.off("gameState");
      socket.off("playerJoined");
      socket.off("playerLeft");
      socket.off("roomFull");
      socket.off("playAgainRequest");
      socket.off("playAgainConfirmed");
      socket.off("roomExpired");
      socket.off("roomDeleted");
      socket.off("roomNotFound");
      socket.off("error");
    };
  }, [socket, players]);

  // Setup waiting timer
  useEffect(() => {
    if (waitingTimerRef.current) {
      clearTimeout(waitingTimerRef.current);
      waitingTimerRef.current = null;
    }

    if (gameStatus === "waiting" && roomId) {
      waitingTimerRef.current = setTimeout(() => {
        setShowTimeoutPopup(true);
        if (socket) {
          socket.emit("expireRoom", { roomId: roomId });
        }
      }, 120000);
    }

    return () => {
      if (waitingTimerRef.current) {
        clearTimeout(waitingTimerRef.current);
      }
    };
  }, [gameStatus, roomId]);

  // Clear timer when game starts
  useEffect(() => {
    if (gameStatus === "playing" && waitingTimerRef.current) {
      clearTimeout(waitingTimerRef.current);
      waitingTimerRef.current = null;
    }
  }, [gameStatus]);

  // Generate board on mount
  useEffect(() => {
    const tempBoard = [];
    
    for (let row = 0; row < 10; row++) {
      for (let col = 0; col < 10; col++) {
        let cellNumber;
        
        if (row % 2 === 0) {
          cellNumber = (9 - row) * 10 + (10 - col);
        } else {
          cellNumber = (9 - row) * 10 + (col + 1);
        }
        
        tempBoard.push({ 
          id: cellNumber, 
          row: row, 
          col: col 
        });
      }
    }
    
    setBoard(tempBoard);
  }, []);

  const handleApiResponse = async (points) => {
        // Use ref for immediate synchronous check
        if (apiCallMadeRef.current) {
          console.log("API call already made, skipping duplicate call for session:");
          return;
        }
        apiCallMadeRef.current = true; // Set ref immediately
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "SnakeAndLadder",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        apiCallMadeRef.current = false;
      }
    } catch (error) {
      console.error("API call failed:", error);
      apiCallMadeRef.current = false;
    }
  };

  const checkWinner = (currentPosition) => {
    if (currentPosition >= 100) {
      return true; // Game ends when position is 100 or more
    }
    return false;
  };

  const handleGameOver = (winningPlayer) => {
    setGameStatus("finished");
    setWinner(winningPlayer);
    setGameFinished(true);

    // Store winner's socket ID for play again functionality
    if (winningPlayer === "You" || winningPlayer === "Player 1" || winningPlayer === "Player 2") {
      setLastWinnerSocketId(socket.id); // Player won
    } else if (winningPlayer === "Computer") {
      setLastWinnerSocketId(null); // Computer won, no socket ID
    } else {
      setLastWinnerSocketId(null); // Draw or other cases
    }

    if (winningPlayer === "Draw") {
      // Set points to 0 for draws
      const points = 0;
      setScore(points);
      handleApiResponse(points.toString());
    } else if (winningPlayer === "You" || winningPlayer === "Player 1" || winningPlayer === "Player 2") {
      // Player won (either in single player or multiplayer)
      const points =  2000;
      setScore(points);
      if (!apiCallMadeRef.current){
      handleApiResponse(points.toString());
      }
    } else if (winningPlayer === "Computer") {
      // Computer won
      const points = 0;
      setScore(points);
      handleApiResponse(points.toString());
    } else if (winningPlayer) {
      // Any other winner (fallback)
      const points = 0;
      setScore(points);
      handleApiResponse(points.toString());
    }
  };

  const rollDice = () => {
    if (rolling || !isMyTurn || gameStatus !== "playing") return;

    setDiceRolling(true);
    
    // We'll send the final dice value after it's determined
    // No need to notify about rolling animation
    
    // Simulate dice rolling animation
    const rollInterval = setInterval(() => {
      setDiceValue(Math.ceil(Math.random() * 6));
    }, 100);
    
    // Stop rolling after 1 second and show final result
    setTimeout(() => {
      clearInterval(rollInterval);
      setDiceRolling(false);
      
      let roll = Math.ceil(Math.random() * 6);
      setDiceValue(roll);
      setRolling(true);
      
      // If in multiplayer mode, notify opponent about final dice value and target position
      if (gameMode === 'multiplayer' && socket) {
        const playerIndex = players.indexOf(socket.id);
        const target = myPosition + roll > 100 ? 100 : myPosition + roll;
        
        const notifyDiceValueState = {
          board: board,
          players: players,
          currentPlayer: socket.id,
          gameStatus: "playing",
          roomId: roomId,
          position: playerIndex === 0 ? myPosition : opponentPosition,
          opponentPosition: playerIndex === 0 ? opponentPosition : myPosition,
          opponentDiceValue: roll,
          opponentMoving: true,
          opponentTargetPosition: target,
          points: {
            winner: 0,
            loser: 0,
            winnerSocketId: null,
            loserSocketId: null
          }
        };
        
        socket.emit("updateGameState", notifyDiceValueState);
      }

      // Show dice for a moment before starting movement
      setTimeout(() => {
        let target = myPosition + roll;
        if (target > 100) {
          target = 100; // Cap at 100
        }
        animateMove(target, roll);
      }, 800); // Wait 800ms to show the dice face
    }, 1000);
  };

  const animateMove = (target, roll) => {
    let current = myPosition;
    let step = 0;

    const interval = setInterval(() => {
      if (step < roll) {
        current++;
        // Ensure position never exceeds 100
        if (current > 100) {
          current = 100;
        }
        setMyPosition(current);
        step++;
      } else {
        clearInterval(interval);

        if (jumps[current]) {
          const newPosition = jumps[current];
          setMyPosition(newPosition);
          current = newPosition;
          
          // If in multiplayer mode, notify opponent about the jump
          if (gameMode === 'multiplayer' && socket) {
            const playerIndex = players.indexOf(socket.id);
            const jumpUpdateState = {
              board: board,
              players: players,
              currentPlayer: socket.id,
              gameStatus: "playing",
              roomId: roomId,
              position: playerIndex === 0 ? newPosition : opponentPosition,
              opponentPosition: playerIndex === 0 ? opponentPosition : newPosition,
              points: {
                winner: 0,
                loser: 0,
                winnerSocketId: null,
                loserSocketId: null
              }
            };
            
            socket.emit("updateGameState", jumpUpdateState);
          }
        }

        setRolling(false);

        // Check for winner
        const winningPlayer = checkWinner(current);
        if (winningPlayer) {
          if (gameMode === 'single') {
            handleGameOver("You");
          } else {
            // Multiplayer mode: determine which player this is and sync with server
            const playerIndex = players.indexOf(socket.id);
            const playerName = playerIndex === 0 ? "Player 1" : "Player 2";
            
            // Set winner and game over state locally
            setLastWinnerSocketId(socket.id); // Store winner's socket ID for play again
            setWinner(playerName);
            setGameStatus("finished");
            setGameFinished(true);
            
            // Calculate points for winner
            const winnerPoints = userDetails?.earlyUsersLimitReached ? 1000 : 2000;
            const loserPoints = 0;

            // Send final game state to server so both players receive it
            const finalGameState = {
              board: board,
              players: players,
              currentPlayer: currentPlayer,
              gameStatus: "finished",
              roomId: roomId,
              position: playerIndex === 0 ? current : opponentPosition,
              opponentPosition: playerIndex === 0 ? opponentPosition : current,
              winner: socket.id, // Send socket ID as winner
              points: {
                winner: winnerPoints,
                loser: loserPoints,
                winnerSocketId: socket.id,
                loserSocketId: players.find(id => id !== socket.id)
              }
            };

            if (socket) {
              socket.emit("updateGameState", finalGameState);
            }
            console.log( userDetails?.earlyUsersLimitReached , " userDetails?.earlyUsersLimitReached ");
            // Handle points for winner
            const points = userDetails?.earlyUsersLimitReached ? 1000 : 2000;
            setScore(points);
            if (!apiCallMadeRef.current){
            handleApiResponse(points.toString());
            }
          }
        } else {
          // Check if player rolled a six - if so, they get another turn
          if (roll === 6) {
            // Player gets another turn
            if (gameMode === 'multiplayer') {
              // Update game state but keep the same player's turn
              const playerIndex = players.indexOf(socket.id);
              const updatedGameState = {
                board: board,
                players: players,
                currentPlayer: socket.id, // Keep current player's turn
                gameStatus: "playing",
                roomId: roomId,
                position: playerIndex === 0 ? current : opponentPosition,
                opponentPosition: playerIndex === 0 ? opponentPosition : current,
                rollMessage: "Opponent rolled a 6! They get another turn!",
                points: {
                  winner: 0,
                  loser: 0,
                  winnerSocketId: null,
                  loserSocketId: null
                }
              };
              
              // Keep turn with current player
              setIsMyTurn(true);
              
              // Show message that player gets another turn
              setSuccessMessage("You rolled a 6! Roll again!");
              setTimeout(() => setSuccessMessage(""), 3000);
              
              if (socket) {
                socket.emit("updateGameState", updatedGameState);
              }
            } else {
              // Single player mode: Player gets another turn
              setIsMyTurn(true);
              setSuccessMessage("You rolled a 6! Roll again!");
              setTimeout(() => setSuccessMessage(""), 3000);
            }
          } else if (gameMode === 'multiplayer') {
            // Multiplayer mode: Switch turns and sync with server (for non-6 rolls)
            const nextPlayer = players.find((id) => id !== currentPlayer);
            // Determine which player we are to send correct positions
            const playerIndex = players.indexOf(socket.id);
            const updatedGameState = {
              board: board,
              players: players,
              currentPlayer: nextPlayer,
              gameStatus: "playing",
              roomId: roomId,
              position: playerIndex === 0 ? current : opponentPosition,
              opponentPosition: playerIndex === 0 ? opponentPosition : current,
              points: {
                winner: 0,
                loser: 0,
                winnerSocketId: null,
                loserSocketId: null
              }
            };

            setCurrentPlayer(nextPlayer);
            setIsMyTurn(false);

            if (socket) {
              socket.emit("updateGameState", updatedGameState);
            }
          } else {
            // Single player mode: Switch to computer's turn (for non-6 rolls)
            setIsMyTurn(false);
          }
        }
      }
    }, 300);
  };

  // Computer AI for single player mode
  const computerTurn = () => {
    if (gameMode !== 'single' || isMyTurn || gameStatus !== "playing") return;

    setComputerThinking(true);
    setOpponentDiceRolling(true);
    
    // Simulate computer thinking and dice rolling
    setTimeout(() => {
      // Simulate dice rolling animation for computer
      const rollInterval = setInterval(() => {
        setOpponentDiceValue(Math.ceil(Math.random() * 6));
      }, 100);
      
      // Stop rolling after 1 second and show final result
      setTimeout(() => {
        clearInterval(rollInterval);
        setOpponentDiceRolling(false);
        
        const roll = Math.ceil(Math.random() * 6);
        setOpponentDiceValue(roll);

        const target = opponentPosition + roll > 100 ? 100 : opponentPosition + roll;
        let current = opponentPosition;
        let step = 0;

        const interval = setInterval(() => {
          if (step < roll) {
            current++;
            // Ensure position never exceeds 100
            if (current > 100) {
              current = 100;
            }
            setOpponentPosition(current);
            step++;
          } else {
            clearInterval(interval);

            if (jumps[current]) {
              setOpponentPosition(jumps[current]);
              current = jumps[current];
            }

            setComputerThinking(false);

            // Check for winner
            const winningPlayer = checkWinner(current);
            if (winningPlayer) {
              handleGameOver("Computer");
            } else if (roll === 6) {
              // Computer rolled a 6, gets another turn
              setSuccessMessage("Computer rolled a 6! Computer gets another turn!");
              setTimeout(() => setSuccessMessage(""), 3000);
              
              // Give a small delay before computer rolls again
              setTimeout(() => {
                computerTurn();
              }, 1500);
            } else {
              // Switch back to player
              setIsMyTurn(true);
            }
          }
        }, 300);
      }, 1000); // Wait 1 second for dice rolling animation
    }, 1000 + Math.random() * 1000); // Random delay to make it feel more natural
  };

  // Trigger computer turn when it's computer's turn
  useEffect(() => {
    if (gameMode === 'single' && !isMyTurn && gameStatus === "playing" && !computerThinking) {
      computerTurn();
    }
  }, [isMyTurn, gameStatus, gameMode, computerThinking]);



  const startOverNewGame = () => {
    if (roomId && socket && gameMode === 'multiplayer') {
      // Notify other players that this player is leaving
      socket.emit('playerLeft', { roomId: roomId });
      // Don't emit expireRoom for manual exits - this prevents redirecting other players
    }
    
    // Reset all game state
    setGameStatus("initial");
    setWinner(null);
    setGameFinished(false);
    setMyPosition(1);
    setOpponentPosition(1);
    setRoomId(null);
    setPlayerSymbol(null);
    setInputRoomId("");
    setShowTimeoutPopup(false);
    setPlayers([]);
    setCurrentPlayer(null);
    setPlayAgainRequested(false);
    setIRequestedPlayAgain(false);
    setErrorMessage("");
    setShowGameModeSelection(true);
    setGameMode(null);
    setScore(0);
    setDiceValue(1);
    setRolling(false);
    setDiceRolling(false);
    setOpponentDiceRolling(false);
    setComputerThinking(false);
    setIsMyTurn(false);
    setLastWinnerSocketId(null); // Reset winner for new game
    apiCallMadeRef.current = false; // Reset API call flag for new game
    
    // Regenerate the board
    const tempBoard = [];
    for (let row = 0; row < 10; row++) {
      for (let col = 0; col < 10; col++) {
        let cellNumber;
        
        if (row % 2 === 0) {
          cellNumber = (9 - row) * 10 + (10 - col);
        } else {
          cellNumber = (9 - row) * 10 + (col + 1);
        }
        
        tempBoard.push({ 
          id: cellNumber, 
          row: row, 
          col: col 
        });
      }
    }
    setBoard(tempBoard);
  };

  const playAgainInSameSession = () => {
    if (gameMode === 'multiplayer') {
      setPlayAgainRequested(true);
      setIRequestedPlayAgain(true);
      socket.emit("playAgainRequest", { roomId: roomId });
    }
    else {
      setMyPosition(1);
      setOpponentPosition(1);
      setDiceValue(1);
      // Winner should get the first turn - if player won, they go first; if computer won, computer goes first
      setIsMyTurn(lastWinnerSocketId === socket.id || lastWinnerSocketId === null);
      setGameStatus("playing");
      setWinner(null);
      setGameFinished(false);
      setScore(0);
      setRolling(false);
      setDiceRolling(false);
      setOpponentDiceRolling(false);
      setComputerThinking(false);
      apiCallMadeRef.current = false; // Reset API call flag for new game
    }
  };

  const confirmPlayAgain = () => {
    if (gameMode === 'multiplayer') {
      setMyPosition(1);
      setOpponentPosition(1);
      setGameStatus("playing");
      setWinner(null);
      setGameFinished(false);
      setShowTimeoutPopup(false);
      setPlayAgainRequested(false);
      setIRequestedPlayAgain(false);
      apiCallMadeRef.current = false; // Reset API call flag for new game

      // Winner should get the first turn - use the stored winner's socket ID
      const winnerPlayer = lastWinnerSocketId || currentPlayer;
      setCurrentPlayer(winnerPlayer);
      setIsMyTurn(winnerPlayer === socket.id);

      const newGameState = {
        board: board,
        players: players,
        currentPlayer: winnerPlayer, // Winner gets first turn
        gameStatus: "playing",
        roomId: roomId,
        position: 1,
        opponentPosition: 1,
        winner: null,
        points: {
          winner: 0,
          loser: 0,
          winnerSocketId: null,
          loserSocketId: null
        }
      };

      socket.emit("updateGameState", newGameState);
      socket.emit("playAgainConfirmed", newGameState);
    }
  };

  const startNewGame = () => {
    const newRoomId = uuidv4();
    setMyPosition(1);
    setOpponentPosition(1);
    setGameStatus("waiting");
    setWinner(null);
    setGameFinished(false);
    setRoomId(newRoomId);
    setErrorMessage("");
    socket.emit("joinRoom", { roomId: newRoomId, gameType: "snakeandladder" });
  };

  const joinGame = (roomIdToJoin) => {
    if (!roomIdToJoin) {
      setErrorMessage("Please enter a Room ID");
      return;
    }
    
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(roomIdToJoin)) {
      setErrorMessage("Invalid Room ID format. Please check the ID and try again.");
      return;
    }
    
    setMyPosition(1);
    setOpponentPosition(1);
    setGameStatus("waiting");
    setWinner(null);
    setGameFinished(false);
    setErrorMessage("");
    socket.emit("joinRoom", { roomId: roomIdToJoin, gameType: "snakeandladder" });
  };

  const toogleMenu = () => {
    playClick();
    setErrorMessage("");
    
    // Show confirmation dialog if user is in a game
    if (gameStatus === "playing" || gameStatus === "waiting" || roomId) {
      Swal.fire({
        title: 'Exit Game?',
        text: 'Are you sure you want to exit the game? This will end the current session.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff4444',
        cancelButtonColor: '#4a90e2',
        confirmButtonText: 'Yes, Exit',
        cancelButtonText: 'Cancel',
        background: 'rgba(0, 0, 0, 0.9)',
        color: '#fff',
        customClass: {
          popup: 'swal2-popup-dark',
          title: 'swal2-title-dark',
          content: 'swal2-content-dark'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // User confirmed exit, proceed with the original functionality
          if (roomId && socket && gameMode === 'multiplayer') {
            // Notify other players that this player is leaving
            socket.emit('playerLeft', { roomId: roomId });
            // Don't emit expireRoom for manual exits - this prevents redirecting other players
          }
          if (roomId) {
            setRoomId(null);
            setGameStatus("initial");
          } else if (!showGameModeSelection) {
            setShowGameModeSelection(true);
            setGameStatus("initial");
          } else {
            updateUserInfo((prev) => ({
              ...prev,
              isPlay: false,
              currentComponent: task,
              currentComponentText: "task",
              lastComponent: userDetails?.userDetails.currentComponent,
              lastComponentText: userDetails?.userDetails.currentComponentText,
              isMenu: true,
              menuCount: userDetails?.userDetails?.menuCount + 1,
            }));
          }
        }
        // If user cancels, do nothing (stay in the game)
      });
    } else {
      // No confirmation needed if not in a game, proceed directly
      if (roomId) {
        setRoomId(null);
        setGameStatus("initial");
      } else if (!showGameModeSelection) {
        setShowGameModeSelection(true);
        setGameStatus("initial");
      } else {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: task,
          currentComponentText: "task",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: true,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
      }
    }
  };

  const copyToClipboard = async (text) => {
    try {
      // If Clipboard API is available and not sandboxed
      if (navigator.clipboard && window.isSecureContext && window.top === window.self) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for Telegram or iframe contexts
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.width = "1px";
        textArea.style.height = "1px";
        textArea.style.padding = "0";
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
  
      setCopySuccess("Copied!");
      setTimeout(() => setCopySuccess(""), 2000);
    } catch (err) {
      console.error("Copy failed:", err);
      setCopySuccess("Failed to copy");
    }
  };

  const navigateToSinglePlayer = () => {
    playClick();
    setShowTimeoutPopup(false);
    setErrorMessage("");
    setGameMode('single');
    setGameStatus("playing");
    setIsMyTurn(true);
    setShowGameModeSelection(false);
    
    // Reset all game state for single player
    setMyPosition(1);
    setOpponentPosition(1);
    setWinner(null);
    setGameFinished(false);
    setScore(0);
    setDiceValue(1);
    setRolling(false);
    setDiceRolling(false);
    setOpponentDiceRolling(false);
    setComputerThinking(false);
    setPlayerSymbol("You"); // Set player symbol for single player mode
    apiCallMadeRef.current = false; // Reset API call flag for new game
    
    // Ensure board is properly generated
    if (!board || board.length === 0) {
      const tempBoard = [];
      for (let row = 0; row < 10; row++) {
        for (let col = 0; col < 10; col++) {
          let cellNumber;
          
          if (row % 2 === 0) {
            cellNumber = (9 - row) * 10 + (10 - col);
          } else {
            cellNumber = (9 - row) * 10 + (col + 1);
          }
          
          tempBoard.push({ 
            id: cellNumber, 
            row: row, 
            col: col 
          });
        }
      }
      setBoard(tempBoard);
    }
  };

  const selectMultiplayerMode = () => {
    // setShowBettingUI(true);
    playClick();
    setShowGameModeSelection(false);
    setGameMode('multiplayer');
    setShowBettingUI(false);
    setShowGameModeSelection(false);

    
  };
  const OpenStartScreen = () => {
    playClick();
    setShowGameModeSelection(false);
    setGameMode('multiplayer');
    setShowBettingUI(false);
  };

  const selectSinglePlayerMode = () => {
    playClick();
    navigateToSinglePlayer();
  };

  const handleExitWaitingRoom = () => {
    Swal.fire({
      title: 'Exit Waiting Room?',
      text: 'Are you sure you want to leave? This will close the room and any waiting players will be disconnected.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff4444',
      cancelButtonColor: '#4a90e2',
      confirmButtonText: 'Yes, Exit',
      cancelButtonText: 'Cancel',
      background: 'rgba(0, 0, 0, 0.9)',
      color: '#fff',
      customClass: {
        popup: 'swal2-popup-dark',
        title: 'swal2-title-dark',
        content: 'swal2-content-dark'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        if (roomId && socket && gameMode === 'multiplayer') {
          // Notify other players that this player is leaving
          socket.emit('playerLeft', { roomId: roomId });
          // Don't emit expireRoom for manual exits - this prevents redirecting other players
        }
        setRoomId(null);
        setGameStatus("initial");
        setShowGameModeSelection(true);
      }
    });
  };

  const startGame = () => {
    if (gameMode === 'single') {
      setMyPosition(1);
      setOpponentPosition(1);
      setDiceValue(1);
      setIsMyTurn(true);
      setGameStatus("playing");
      setWinner(null);
      setGameFinished(false);
      setScore(0);
      setRolling(false);
      setDiceRolling(false);
      setOpponentDiceRolling(false);
      setComputerThinking(false);
    } else {
      startNewGame();
    }
  };
  return (
    <div className="snake-ladder-container" style={{ pointerEvents: "fill" }}>
      {/* Debug Info - Remove this later */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div style={{ 
          position: 'fixed', 
          top: '10px', 
          right: '10px', 
          background: 'rgba(0,0,0,0.8)', 
          color: 'white', 
          padding: '10px', 
          borderRadius: '5px', 
          fontSize: '12px',
          zIndex: 1000
        }}>
          <div>Game Status: {gameStatus}</div>
          <div>Game Finished: {gameFinished ? 'Yes' : 'No'}</div>
          <div>Winner: {winner || 'None'}</div>
          <div>Game Mode: {gameMode}</div>
          <div>My Position: {myPosition}</div>
          <div>Opponent Position: {opponentPosition}</div>
          <div>Is My Turn: {isMyTurn ? 'Yes' : 'No'}</div>
        </div>
      )} */}
      
      {(!roomId || gameStatus !== "waiting") && (
        <img
          onClick={toogleMenu}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
          className="cancel-snakeandladder"    
          style={{ cursor: "pointer" }}
        />
      )}
      
      <div className="col-12">
        <h2 className="welcometextmeme">Snakes and Ladders</h2>
        <p className="multiplayer-tic-subtitle">
          {showGameModeSelection ? "CHOOSE YOUR GAME MODE" : 
           gameMode === 'single' ? "SINGLE PLAYER - CHALLENGE TheMemeTV!" : 
           "MULTIPLAYER MODE - PLAY WITH FRIENDS!"}
        </p>
      </div>

      {errorMessage && (
        <div className="multiplayer-tic-error">
          <p>{errorMessage}</p>
        </div>
      )}
      
      {successMessage && (
        <div className="snake-ladder-success-message">
          <p>{successMessage}</p>
        </div>
      )}

      {showGameModeSelection && (
        <div className="multiplayer-tic-game-mode-selection">
          <button 
            className="multiplayer-tic-playgame" 
            onClick={selectSinglePlayerMode}
          >
            🤖 PLAY WITH TheMemeTV
            <div className="button-description">Challenge TheMemeTV</div>
          </button>
          <button 
            className="multiplayer-tic-playgame" 
            onClick={selectMultiplayerMode}
          >
            👥 MULTIPLAYER
            <div className="button-description">Play with Friends Online</div>
          </button>
        </div>
      )}

      {!showGameModeSelection && gameMode === 'multiplayer' && (gameStatus === "waiting" || gameStatus === "initial") && !roomId && (
        <div className="multiplayer-tic-options">
          <button className="multiplayer-tic-playgame" onClick={startNewGame}>
            CREATE NEW GAME
          </button>
          <div className="multiplayer-tic-join-game">
            <input
              type="text"
              placeholder="Enter Room ID"
              value={inputRoomId}
              onChange={(e) => setInputRoomId(e.target.value)}
            />
            <button
              className="multiplayer-tic-playgame"
              onClick={() => joinGame(inputRoomId)}
            >
              JOIN GAME
            </button>
          </div>
        </div>
      )}
 {showBettingUI && gameMode === 'multiplayer' && (
        <div className="multiplayer-tic-overlay">
          <div className="multiplayer-tic-popup betting-popup">
            <div className="betting-popup-header">
              <h2>🎯 MULTIPLAYER BETTING</h2>
              <p>Place your bet to start the game!</p>
            </div>
            
            <div className="betting-details">
              <div className="bet-amount-display">
                <span className="bet-label">BET AMOUNT:</span>
                <span className="bet-value">{betAmount} tokens</span>
              </div>
              
              <div className="betting-rules">
                <h4>📋 GAME RULES:</h4>
                <ul>
                  <li>Both players bet {betAmount} tokens</li>
                  <li>Winner takes the entire pot ({betAmount * 2} tokens)</li>
                  <li>Loser gets 0 tokens</li>
                  <li>Game starts after both players place bets</li>
                </ul>
              </div>
            </div>

            <div className="betting-popup-actions">
              <button 
                className="multiplayer-tic-playgame confirm-bet-button" 
                onClick={() => {
                  setShowBettingUI(false);
                  setShowGameModeSelection(false);
                  // OpenStartScreen();
                }}
              >
                🎲 CONTINUE TO GAME
              </button>
              
              <button 
                className="multiplayer-tic-playgame cancel-bet-button" 
                onClick={() => {
                  setShowBettingUI(false);
                  setShowGameModeSelection(true);
                  setGameMode(null);
                }}
              >
                ❌ CANCEL
              </button>
            </div>
          </div>
        </div>
      )}

      {roomId && gameStatus === "waiting" && (
        <div className="multiplayer-tic-waiting-room">
          <div className="waiting-room-header">
            <h3>Waiting Room</h3>
            <button 
              className="waiting-room-exit-button"
              onClick={handleExitWaitingRoom}
            >
              ✕
            </button>
          </div>
          <div className="waiting-status">
            <h4 style={{ color: '#4a90e2', margin: '0 0 10px 0', fontSize: '18px' }}>Room ID:</h4>
            <div className="multiplayer-tic-room-id-container">
              <input
                type="text"
                value={roomId}
                readOnly
                className="multiplayer-tic-room-id-display"
              />
              <button
                className="multiplayer-tic-copy-button"
                onClick={() => copyToClipboard(roomId)}
              >
                {copySuccess || "Copy"}
              </button>
            </div>
            <p className="multiplayer-tic-subtitle">Share this Room ID with your friend to play together</p>
            <p className="multiplayer-tic-subtitle">Wait till the opponent joins the game</p>
          </div>
        </div>
      )}

      {gameStatus === "playing" && (
      <div className="snake-ladder-game-layout">
        <div className="snake-ladder-game-board">
          <div className="snake-ladder-main-container">
              {board?.map((box) => (
              <div
                  key={box?.id}
                className="snake-ladder-board-cell"
                  id={`box${box?.id}`}
                style={{
                    gridRow: box?.row + 1,
                    gridColumn: box?.col + 1
                }}
              >
                  {/* <span className="snake-ladder-cell-number">{box?.id}</span> */}
                  {myPosition === box?.id && (
                  <div className="snake-ladder-player-container">
                    <img
                      ref={counterRef}
                      className="snake-ladder-player-image"
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/snake-coin.png"
                      alt="pawn"
                    />
                  </div>
                )}
                  {opponentPosition === box?.id && (
                    <div className="snake-ladder-player-container">
                      <img
                        className="snake-ladder-player-image opponent"
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        alt="opponent"
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
          
        <div className="snake-ladder-side-panel">
          <div className="snake-ladder-controls">
              {/* <h3 className="snake-ladder-position">Your Position: {myPosition}</h3> */}
              {/* {gameMode === 'multiplayer' && (
                <h3 className="snake-ladder-position">Opponent Position: {opponentPosition}</h3>
              )}
              {gameMode === 'single' && (
                <h3 className="snake-ladder-position">Computer Position: {opponentPosition}</h3>
              )} */}
              
              <div className="snake-ladder-game-status">
                <p>{isMyTurn ? "Your turn" : gameMode === 'single' ? "Computer's turn" : "Opponent's turn"}</p>
                {gameMode === 'multiplayer' && <p>You are playing as: {playerSymbol}</p>}
              </div>
              
              {/* <button className="snake-ladder-button" onClick={startGame}>
              New Game
              </button> */}
              
              <div className="snake-ladder-dice-container">
                {/* Player's dice */}
                <div className="snake-ladder-player-dice">
                  <p>Your Dice:</p>
                  <button 
                    className="snake-ladder-dice" 
                    onClick={rollDice} 
                    disabled={rolling || diceRolling || !isMyTurn}
                  >
                    {diceRolling ? "🎲" : diceFaces[diceValue] ? (
                      <img 
                        src={diceFaces[diceValue]} 
                        alt={`Dice ${diceValue}`}
                        style={{ width: "30px", height: "30px" }}
                      />
                    ) : ""}
                  </button>
                  {diceRolling && <p className="snake-ladder-rolling">Rolling...</p>}
                  {rolling && <p className="snake-ladder-rolling">Moving...</p>}
                </div>
                
                {/* Opponent's dice - always show in both modes */}
                <div className="snake-ladder-opponent-dice">
                  <p>{gameMode === 'single' ? "Computer's Dice:" : "Opponent's Dice:"}</p>
                  <div className="snake-ladder-dice opponent-dice">
                    {opponentDiceRolling ? "🎲" : diceFaces[opponentDiceValue] ? (
                      <img 
                        src={diceFaces[opponentDiceValue]} 
                        alt={`Opponent Dice ${opponentDiceValue}`}
                        style={{ width: "30px", height: "30px" }}
                      />
                    ) : ""}
                  </div>
                  {opponentDiceRolling && <p className="snake-ladder-rolling">Rolling...</p>}
                  {computerThinking && !opponentDiceRolling && <p className="snake-ladder-rolling">Computer is Moving...</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {gameFinished && (
        <div className="multiplayer-tic-overlay">
          <div className="multiplayer-tic-popup">
            <div className="multiplayer-tic-popup-content">
              <h2 className="multiplayer-tic-epic">Game Over!</h2>
              <div className="row text-center">
                <div className="col-12">
                  <div
                    className="multiplayer-tic-epic-div"
                    style={{ padding: "30px 40px" }}
                  >
                    <p className="multiplayer-tic-points-label">
                      TOKENS EARNED
                    </p>
                    <div className="multiplayer-tic-points-value">
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        alt="logo"
                      />
                      <p className="multiplayer-tic-points-number">{score}</p>
                    </div>
                  </div>
                  <p className="multiplayer-tic-winner-text">
                    {winner === "Draw"
                      ? "It's a draw!"
                      : winner === "You"
                      ? "You won!"
                      : winner === "Disconnected"
                      ? "Opponent Disconnected"
                      : winner === "Computer"
                      ? "Computer won!"
                      : winner === playerSymbol
                      ? "You won!"
                      : winner === "Player 1" || winner === "Player 2"
                      ? "Opponent won!"
                      : "Game Over!"}
                  </p>
                </div>
              </div>
            </div>
            <div className="multiplayer-tic-playagain">
              {winner === "Disconnected" ? (
                // Only show RETURN TO MENU when opponent disconnects
                <button
                  className="multiplayer-tic-playgame"
                  onClick={startOverNewGame}
                >
                  RETURN TO MENU
                </button>
              ) : !playAgainRequested ? (
                <>
                  <button
                    className="multiplayer-tic-playgame"
                    onClick={playAgainInSameSession}
                  >
                    PLAY AGAIN
                  </button>
                  <button
                    className="multiplayer-tic-playgame"
                    onClick={startOverNewGame}
                  >
                    RETURN TO MENU
                  </button>
                </>
              ) : iRequestedPlayAgain ? (
                <>
                  <p className="multiplayer-tic-waiting-text">
                    Waiting for other player to respond...
                  </p>
                  <button
                    className="multiplayer-tic-playgame"
                    onClick={startOverNewGame}
                  >
                    RETURN TO MENU
                  </button>
                </>
              ) : (
                <>
                  <p className="multiplayer-tic-waiting-text">
                    Other player wants to play again!
                  </p>
                  <button
                    className="multiplayer-tic-playgame"
                    onClick={confirmPlayAgain}
                  >
                    CONFIRM PLAY AGAIN
                  </button>
                  <button
                    className="multiplayer-tic-playgame"
                    onClick={startOverNewGame}
                  >
                    RETURN TO MENU
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {showTimeoutPopup && (
        <div className="multiplayer-tic-overlay">
          <div className="multiplayer-tic-popup">
            <div className="multiplayer-tic-popup-content">
              <h2 className="multiplayer-tic-epic">No Player Joined</h2>
              <p>It seems no one has joined your game within the time limit.</p>
              <p>What would you like to do?</p>
            </div>
            <div className="multiplayer-tic-playagain">
              <button
                className="multiplayer-tic-playgame"
                onClick={startOverNewGame}
              >
                RETURN TO MENU
              </button>
              <button
                className="multiplayer-tic-playgame"
                onClick={navigateToSinglePlayer}
              >
                PLAY WITH COMPUTER
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SnakeAndLadder;

